import React from "react";
import GitHubCalendar from "react-github-calendar";
import { Row } from "react-bootstrap";

function Github() {
  const colourTheme = {
    background: "transparent",
    text: "#4C6796",
    grade4: "#4C6796",
    grade3: "#495C83",
    grade2: "#607EAA",
    grade1: "#1C3879",
    grade0: "#FEFBF6",
  };
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
      <h1 className="project-heading" style={{ paddingBottom: "20px" }}>
      All the days  <strong className="purple">I coded</strong>
      </h1>
      <GitHubCalendar
        username="afreul-joy"
        blockSize={15}
        blockMargin={5}
        theme={colourTheme}
        fontSize={16}
      />
    </Row>
  );
}

export default Github;
